import { CtaButtonStyle } from "@/common/interfaces/CtaLinkItem";
import { ArticleCtaProps } from "@/components/ArticleText/ArticleText.utils";
import { getComponentProps } from "@/utils/vueUtils";

export interface IArticleTextModuleViewModel extends ArticleCtaProps {
  Text: string;
  HasDropCap: boolean;
}

export const ArticleTextModuleViewModel = {
  props: getComponentProps<IArticleTextModuleViewModel>({
    Text: '',
    HasDropCap: false,
    NewsletterSingUpCta: {
      Button: {
        ButtonStyle: CtaButtonStyle.Black,
        Text:"",
        Link:"",
        Title: "",
        Action: "Button",
        Target: ""
      },
      Header: "",
      SecondHeader: ""
    },
  }),
}